// Navigation.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import useIsMobile from '../Components/UseIsMobile.js';

const ReportsDD = () => {
  const { accounts } = useMsal();
  const [showDropdown, setShowDropdown] = useState(false);
  const [clients, setClients] = useState([]);
  const isMobile = useIsMobile();
  const [dmstate, setdmState] = useState(false); // ✅ boolean

  const handleMouseEnter = () => setShowDropdown(true);
  const handleMouseLeave = () => setShowDropdown(false);
  const handleClick = () => {
    if (isMobile) setShowDropdown(!showDropdown);
  };

  useEffect(() => {
    fetch('/api/hello')
      .then((r) => r.json())
      .then((data) => setClients(data.clients ?? []))
      .catch((e) => console.error('Error fetching client data:', e));
  console.log(clients);
  }, []);
  

  useEffect(() => {
    // no accounts or no clients -> not DM
    if (!accounts?.length || !clients?.length) {
      setdmState(false);
      return;
    }

    const adUsername = (accounts[0].username || '').toLowerCase();

    // find the client row matching this account
    const match = clients.find(c => (c?.fields?.Email || '').toLowerCase() === adUsername);

    // normalize DM to a boolean (handles true / "true" / 1)
    const rawDm = match?.fields?.DM;
    const isDm =
      rawDm === true ||
      rawDm === 'true' ||
      rawDm === 1 ||
      rawDm === '1' ||
      String(rawDm).toLowerCase() === 'yes';

    setdmState(Boolean(isDm));

    // (Optional) quick debug to verify values coming from your API:
    // console.log({ adUsername, rawDm, isDm, match });
  }, [accounts, clients]);
  
  return (
    <div
      className="navigation"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleClick}
    >
      <span className="nav-item">Reports</span>
      {showDropdown && (
        <div className="dropdown">
          <ul>
            <li><Link to="/spotlights">Situational Reports</Link></li>
            <li><Link to="/reports" className="dropdown-item">Tactical Reports</Link></li>
            <li><Link to="/legacysearch">Legacy Data Search</Link></li>

            {dmstate && ( // ✅ will show when DM normalizes to true
              <li><Link to="/dmreports" className="dropdown-item">DM Reports</Link></li>
            )}
          </ul>
        </div>
      )}
    </div>
  );
};

export default ReportsDD;
